import styled from 'styled-components';

import { TextButton } from '@xing-com/button';

const StyledButton = styled(TextButton)`
  position: fixed;
  right: 0;
  top: 0;
`;

export { StyledButton };
